var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-container"},[(_vm.url)?_c('a',{attrs:{"href":_vm.url,"target":_vm.target,"rel":"opener"}},[_vm._t("default")],2):_c('div',{staticClass:"diff-div-wraper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }